import { Location } from "@grandvisionhq/api-client";
const getCoordinatesMultiCountry = async (apiUrl, request) => {
  const { places } = await Location.getPlacePredictionsExtended(apiUrl, {
    place: request.query
  });
  const place = places?.[0];
  if (!place) {
    throw new Error("No matching place found");
  }
  const details = await Location.getPlaceDetails(apiUrl, { id: place.id });
  return {
    address: place.address?.join(", ") || "",
    coordinates: details.coordinates
  };
};
export {
  getCoordinatesMultiCountry
};
//# sourceMappingURL=get-coordinates-multi-country.js.map
